import { combineReducers } from "redux";
import gameInfo from "./games.reducer";
import login from "./users.reducer";

export default combineReducers({
    gameInfo,
    login
});
